import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';

@Component({
  selector: 'app-web-navbar',
  templateUrl: './web-navbar.component.html',
  styleUrls: ['./web-navbar.component.css']
})
export class WebNavbarComponent implements OnInit {

  isLoginButtonDisabled = false;
  userInfo: any;
  constructor(private service: AuthenticationService) { }

  ngOnInit(): void {
  
    this.service.checkUserAuthenticated().subscribe(
    data => {

      this.userInfo=data.userId;
        console.log(this.userInfo);
        if (this.userInfo <= 0) {
          this.isLoginButtonDisabled = true; 
        } 
        else{
          this.isLoginButtonDisabled = false;
        }
      }
    )
  }
}
